import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'
import { getReport, getReportLevel } from '../helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import DeviceReport from './components/DeviceReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default ({ appCode }) => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, officeId, patientRef, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    setReports(
      await getReport('/reports/device/get', {
        appCode,
        startDate,
        endDate,
        officeId,
        patientRef,
        showArchivedOffices
      })
    )
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Device Report`}
        csvUrl="/reports/device/csv"
        csvPayload={reportSortingState}
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <>
          <ReportHeader
            header="Office"
            title={report.title}
            cardValues={[
              [
                'Total',
                'Responses',
                report.journeys.reduce(
                  (prev, curr) => (prev += curr.responses),
                  0
                )
              ],
              ['Total', 'Journeys', report.journeys.length],
              [
                'Total',
                'Patients',
                new Set(report.journeys.map(val => val.patientRef)).size
              ]
            ]}
          />
          <DeviceReport report={report} />
        </>
      ))}
    </>
  )
}
